import angular from 'angular';
import moment from 'moment';
import swal from 'sweetalert';
import {ModalController} from '../../common/modal.controller.js';

class DetailController {
    constructor($uibModal, Pacijent, Pregled, Nalaz, Uputnica, Pristanak){
        this.id = this.id || {};
        this.$uibModal = $uibModal;
        this.Pacijent = Pacijent;
        this.Pregled = Pregled;
        this.Nalaz = Nalaz;
        this.Uputnica = Uputnica;
        this.Pristanak = Pristanak;
        this.pregledi = [];
        this.nalazi = [];
        this.refreshState();
        this.filterPreglede = {
            pacijent: this.id,
            djelatnost__naziv: ''
        };
        this.searchFields = this.getPregledSearchFields();
    }

    getPregledSearchFields() {
        let that = this;
        return [
            {
                key: 'djelatnost',
                type: 'huiSelect',
                templateOptions: {
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Pretraživanje po djelatnosti',
                    options: [],
                    allowClear: true,
                    onSelect:"onSelect($item, $model)"
                },
                controller: ['$scope', 'DjelatnostPoliklinike', function ($scope, Model) {
                    Model.findAll().then(function (response) {
                        $scope.to.options = response;
                    });

                    $scope.onSelect = ($item, $model) => {
                        if (angular.isDefined($item)) {
                            that.filterPreglede.djelatnost__naziv = $item.naziv;
                        }else {
                            that.filterPreglede.djelatnost__naziv = '';
                        }

                        that.refreshState();
                    };
                }],
            }
        ];
    }

    refreshState() {
        this.Pacijent.find(this.id).then((data) => {
            this.pacijent = data;

            this.Pregled.findAll(this.filterPreglede).then((data) => {
                this.pregledi = data;
            });

            this.Nalaz.findAll({pacijent: this.pacijent.id}).then((data) => {
                this.nalazi = data;
            });

            this.Uputnica.findAll({pacijent: this.pacijent.id}).then((data) => {
                this.uputnice = data;
            });

            this.Pristanak.findAll({pacijent: this.pacijent.id}).then((data) => {
                this.pristanci = data;
            });
        });
    }

    edit(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<pacijent-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pacijent-form>',
            controller: ModalController,
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    editNapomena(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<pacijent-napomena-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pacijent-napomena-form>',
            controller: ModalController,
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    editPovijestBolesti(item){
        const model = item;
        const modal = this.$uibModal.open({
            template: '<pregled-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pregled-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                },
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });

    }

    newPovijestBolesti() {
        const model = {
            pacijent: this.pacijent.id,
            datum: moment().utc().format('YYYY-MM-DD')
        };
        const modal = this.$uibModal.open({
            template: '<pregled-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pregled-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                },
            },
        });
        modal.result.then((model) => {
            this.refreshState();
        });
    }

    deletePovijestBolesti(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal({
            title: "Brisanje pregleda " + item.redni_broj,
            text: "Za potvrdu brisanja upišite 'da'",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
        },(inputValue) => {
            window.onkeydown = previousWindowKeyDown;
            if (inputValue === false) return false;
            if (inputValue === 'da') {
                this.Pregled.destroy(item.id).then(
                    (data) => {
                        this.refreshState();
                        swal("Pregled obrisan", "Pregled pod rednim brojem " + item.redni_broj + " uspiješno je obrisan", "success");
                    },
                    (error) => {
                        swal("Greška", "Došlo je do greške prilikom brisanja pregleda " + item.redni_broj, "error");
                    });
                return true;
            }
            swal.showInputError("Nedozvoljena vrijednost");
            return false;
        });
    }

    newNalaz() {
        const model = {
            pacijent: this.pacijent.id,
            datum: moment().utc().format('YYYY-MM-DD')
        };
        const modal = this.$uibModal.open({
            template: '<nalaz-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></nalaz-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    editNalaz(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<nalaz-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></nalaz-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    deleteNalaz(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal({
            title: "Brisanje nalaza " + item.redni_broj,
            text: "Za potvrdu brisanja upišite 'da'",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
        },(inputValue) => {
            window.onkeydown = previousWindowKeyDown;
            if (inputValue === false) return false;
            if (inputValue === 'da') {
                this.Nalaz.destroy(item.id).then(
                    (data) => {
                        this.refreshState();
                        swal("Nalaz obrisan", "Nalaz pod rednim brojem " + item.redni_broj + " uspiješno je obrisan", "success");
                    },
                    (error) => {
                        swal("Greška", "Došlo je do greške prilikom brisanja nalaza " + item.redni_broj, "error");
                    });
                return true;
            }
            swal.showInputError("Nedozvoljena vrijednost");
            return false;
        });
    }

    newUputnica() {
        const model = {
            pacijent: this.pacijent.id,
            sifra: this.pacijent.sifra,
            prezime: this.pacijent.prezime,
            ime: this.pacijent.ime,
            datum_rodjenja: this.pacijent.datum_rodjenja,
            jmbg_oib: this.pacijent.jmbg_oib,
            spol: this.pacijent.spol,
            dob: this.pacijent.dob
        };
        const modal = this.$uibModal.open({
            template: '<uputnica-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></uputnica-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });

    }

    editUputnica(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<uputnica-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></uputnica-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    deleteUputnica(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal({
            title: "Brisanje uputnice",
            text: "Za potvrdu brisanja upišite 'da'",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
        },(inputValue) => {
            window.onkeydown = previousWindowKeyDown;
            if (inputValue === false) return false;
            if (inputValue === 'da') {
                this.Uputnica.destroy(item.id).then(
                    (data) => {
                        this.refreshState();
                        swal("Uputnica obrisana", "Uputnica s brojem biopsije " + item.broj_biopsije + " uspiješno je obrisana", "success");
                    },
                    (error) => {
                        swal("Greška", "Došlo je do greške prilikom brisanja uputnice", "error");
                    });
                return true;
            }
            swal.showInputError("Nedozvoljena vrijednost");
            return false;
        });
    }


    newPristanak() {
        const model = {
            pacijent: this.pacijent.id,
            prezime: this.pacijent.prezime,
            ime: this.pacijent.ime,
            datum_rodjenja: this.pacijent.datum_rodjenja,
            adresa: this.pacijent.ulica_kbr
        };
        if (angular.isDefined(this.pacijent.grad) & angular.isString(this.pacijent.grad)) {
            model.adresa = model.adresa + ', ' + this.pacijent.grad;
        }
        const modal = this.$uibModal.open({
            template: '<pristanak-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pristanak-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });

    }

    editPristanak(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<pristanak-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pristanak-form>',
            controller: ModalController,
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    deletePristanak(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal({
            title: "Brisanje pristanka",
            text: "Za potvrdu brisanja upišite 'da'",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
        },(inputValue) => {
            window.onkeydown = previousWindowKeyDown;
            if (inputValue === false) return false;
            if (inputValue === 'da') {
                this.Pristanak.destroy(item.id).then(
                    (data) => {
                        this.refreshState();
                        swal("Pristanak obrisan", "Pristanak za pacijenta " + item.prezime + ' ' + item.ime + " uspiješno je obrisan", "success");
                    },
                    (error) => {
                        swal("Greška", "Došlo je do greške prilikom brisanja pristanka", "error");
                    });
                return true;
            }
            swal.showInputError("Nedozvoljena vrijednost");
            return false;
        });
    }

    searchPreglede(search) {
        this.Pregled.findAll({pacijent: this.pacijent.id, djelatnost__naziv: search}).then((data) => {
            this.pregledi = data;
        });
    }
}

DetailController.$inject = ['$uibModal', 'Pacijent', 'Pregled', 'Nalaz', 'Uputnica', 'Pristanak'];

export {DetailController};



// WEBPACK FOOTER //
// ./app/components/pacijent/detail/detail.controller.js